import { faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { deleteBrand } from "../../redux/features/brands/brandsSlice";

function DeleteBrand({ brandId, refetchBrands }) {
  const dispatch = useDispatch();
  const { deleteBrandLoading } = useSelector((state) => state.brands);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => setIsModalOpen(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await dispatch(deleteBrand(brandId)).unwrap();
      toast.success(`Brand deleted successfully`);
      setIsModalOpen(false);
      refetchBrands();
    } catch {
      toast.error("Failed to delete Brand");
    }
  };
  return (
    <div>
      <button
        onClick={handleOpen}
        className="text-red-600 hover:text-red-800 font-medium"
      >
        <FontAwesomeIcon icon={faTrash} />
      </button>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-lg w-[45%] p-10 relative">
            <button
              onClick={handleClose}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>

            <h2 className="text-xl font-semibold border-b border-gray-200 mb-6 pb-5 text-left">
              Delete Brand
            </h2>
            <p className="text-left text-gray-500 font-medium text-lg">
              Are you sure you want to delete this Brand ?
            </p>

            <div className="flex justify-end gap-3 mt-6">
              <button
                type="button"
                onClick={handleClose}
                className="px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100"
              >
                Close
              </button>
              <button
                onClick={handleSubmit}
                disabled={deleteBrandLoading}
                className={`px-4 py-2 rounded-md bg-red-600 text-white ${
                  deleteBrandLoading ? "cursor-not-allowed bg-red-600/60" : ""
                }`}
              >
                {deleteBrandLoading ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DeleteBrand;
